<div class="page-container">
  <ul class="breadcrumb-container">
    <ng-content></ng-content>
  </ul>
</div>
<div class="horizontal-divider" *ngIf="!noDivider"></div>
